import { formatDate } from './formatDate';
import { formatColor } from './formatColor';
import { formatNumber } from './formatNumber';
import { formatBoolean } from './formatBoolean';
import { formatToString } from './formatToString';

export function defaultFormat(value, dataType = typeof value) {

    // null guards
    if (value === undefined) {
        return null;
    }
    if ((dataType === 'number' || dataType === 'integer') && (isNaN(value) || value === 0x7fffffff || value === 2147483647 || value === '2147483647')) {
        return null;
    }
    if (dataType === 'string' && (value === 'n/a' || value === '\0')) {
        return null;
    }
    if ((dataType === 'bool' || dataType === 'boolean') && value === null) {
        return null;
    }

    if (dataType === 'bool' || dataType === 'boolean') {
        return formatBoolean(value);
    }

    if (dataType === 'date') {
        return formatDate(value, false);
    }

    if (dataType === 'number' || dataType === 'integer') {
        if (value === null || +value === 2147483647) {
            return null;
        } else if (value && value % 1 !== 0) {
            return formatNumber(Number(value), false);
        }
    }

    if (dataType === 'color') {
        if (typeof value === 'string') return value;
        if (!isNaN(+value)) return formatColor(+value);
    }

    return formatToString(value, false); // Default
}
